import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import matrimonyInstance from "../utils/axios";
import {
	LIST_ALL_PROFILES,
	LIST_PROFILES_TO_BE_VERIFIED,
	LIST_SHORTLISTED_PROFILES,
} from "../API_LIST";
import ProfileCard from "../component/section/profileCard2";
import PaginationComponent from "../component/section/PaginatedItems";
import { getDataFromJwt, replaceIdInUrl } from "../utils/utility";
import { useSelector } from "react-redux";
import PageTitle from "./pageTitle";

export default function ProfileShortlist() {
	const [profilesData, setProfilesData] = useState();
	const [pageData, setPageData] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [pageNumber, setPageNumber] = useState(1);
	const [countPerPage, setCountPerPage] = useState(9);
	const choosenProfile = useSelector((state) => state.auth.currentProfile);
	function onPageChanged(key, value) {
		if (key == "pageNumber") {
			setPageNumber(value);
			getProfiles(9, value);
		} else if (key == "countPerPage") {
			setCountPerPage(value);
			getProfiles(value, 1);
		}
	}
	const getProfiles = async (customCountPerPage, customPageNumber) => {
		if (!choosenProfile) {
			setProfilesData([]);
			return;
		}
		let data = {
			limit: customCountPerPage
				? Number.parseInt(customCountPerPage)
				: countPerPage,
			page: customPageNumber ? Number.parseInt(customPageNumber) : pageNumber,
		};
		let url = replaceIdInUrl(
			LIST_SHORTLISTED_PROFILES + `?page=${data?.page}&limit=${data?.limit}`,
			choosenProfile.profile_id,
		);
		matrimonyInstance.get(url).then((response) => {
			setTotalCount(response.data.total_count);
			setPageNumber(response.data.page_number);
			setCountPerPage(response.data.limit);
			setProfilesData(response.data.shortlistedProfiles);
		});
	};

	useEffect(() => {
		getProfiles();
	}, [choosenProfile]);
	return (
		<div>
			<div className="profile-filter-header">
				<h5>Shortlisted Profiles</h5>
			</div>

			<div className="d-flex justify-content-center pb-30 pt-30">
				<div className="profile-card-list">
					<ProfileCard profilesData={profilesData} showShortList={true} />
				</div>
			</div>
			<PaginationComponent
				totalCount={totalCount}
				onValueChanged={onPageChanged}
				pageNumber={pageNumber}
				countPerPage={countPerPage}
			/>
			<div className="contact-text mt-10">
				<h6>
					Please contact us via email at{" "}
					<a className="tetx-blue-card" href="mailto:support@batus.org">
						support@batus.org
					</a>{" "}
					or call us at{" "}
					<a className="tetx-blue-card" href="tel:+1 707 564 6228">
						+1 707 564 6228
					</a>{" "}
					for more details about your selected profile. Kindly mention the
					profile number when reaching out.{" "}
				</h6>
			</div>
		</div>
	);
}
